import { render, staticRenderFns } from "./NewSignup.vue?vue&type=template&id=49aac632"
import script from "./NewSignup.vue?vue&type=script&lang=js"
export * from "./NewSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports